import type { CommunityDetail } from 'models';
import { Classify2LineIcon, Col, Image, Row, Tag, Title } from 'ui';

type P = {
  community: CommunityDetail;
};

const CommunityInfo = ({ community }: P) => (
  <Row gutter={['xs', 0]}>
    <Col>
      <Image borderRadius="small" preview={false} src={community.coverPhoto.url} width={128} />
    </Col>
    <Col flex="1">
      <Row>
        <Col span={24}>
          <Tag color="green" icon={<Classify2LineIcon />}>
            Community
          </Tag>
          <Title level={3} marginBottom>
            {community.name}
          </Title>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default CommunityInfo;
